import { atom } from 'recoil';

export const OnNoticeActivationTypeAtom = atom<'create' | 'edit' | ''>({
	key: 'onNoticeActivation',
	default: '',
});
